<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('cashFlowAndStock.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('cashFlowAndStock.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>{{ $t('cashFlowAndStock.criteria') }}</legend>
                  <!-- <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashFlowAndStock.branch')
                      }}</label>
                      <a-select
                        style="width:100%"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model.number="model.branch_id"
                        :options="branchList"
                      ></a-select>
                      <div class="validate" v-if="errors.has('branch_id')">
                        {{ errors.first('branch_id') }}
                      </div>
                    </div>
                  </div> -->
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashFlowAndStock.date')
                      }}</label>
                      <a-range-picker
                        format="DD-MM-YYYY"
                        :defaultValue="rangeDate"
                        :defaultPickerValue="rangeDate"
                        @change="dateRangeChange"
                      >
                        <template slot="renderExtraFooter"></template>
                      </a-range-picker>
                      <div class="validate" v-if="errors.has('date_range')">
                        {{ errors.first('date_range') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t('cashFlowAndStock.saleName')
                      }}</label>
                      <a-select
                        style="width:100%"
                        :filterOption="
                          (input, option) =>
                            option.componentOptions.children[0].text
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                        "
                        v-model="model.sale_id"
                        :options="seller"
                        mode="multiple"
                        :maxTagCount="1"
                      ></a-select>
                      <div class="validate" v-if="errors.has('sale_id')">
                        {{ errors.first('sale_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="waiting"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('cashFlowAndStock.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import { Errors } from 'form-backend-validation'

export default {
  name: 'cash-flow-and-stock',
  data () {
    return {
      loading: false,
      waiting: false,
      src: null,
      errors: new Errors(),
      seller: [],
      branchList: [],
      rangeDate: [moment(), moment()],
      model: {
        branch_id: undefined,
        sale_id: []
      }
    }
  },
  created () {
    this.fetchData()
    // this.model.branch_id = this.$store.state.authUser.user.default_branch.branch_id
  },
  methods: {
    ...mapActions('report/resource', ['getEmployee']),
    async fetchData () {
      this.loading = true
      // await this.$store
      //   .dispatch('security/user/getBranchAssigned')
      //   .then(response => {
      //     this.branchList = response.data.map(el => ({
      //       value: el.branch_id,
      //       label: el.branch_name_en
      //     }))
      //   })
      await this.getEmployee()
        .then(response => {
          this.seller = response.data.map(el => ({
            value: el.employee_id,
            label: el.employee_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    preview () {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.$store
        .dispatch('report/daily/cashFlowAndStockControl', this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    dateRangeChange (rangeDate) {
      this.$store.commit(
        'report/daily/SET_DATE_FROM',
        rangeDate[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'report/daily/SET_DATE_TO',
        rangeDate[1].format('DD-MM-YYYY')
      )
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit(
      'report/daily/SET_DATE_FROM',
      moment().format('DD-MM-YYYY')
    )
    this.$store.commit(
      'report/daily/SET_DATE_TO',
      moment().format('DD-MM-YYYY')
    )
    next()
  }
}
</script>
